import { Injectable } from '@angular/core';

export interface ILocalStorageService {
  createUserAndStoreInLocal: (userData: any) => void;
  getItem: (name: string) => string;
  removeItem: (name: string) => void;
  setItem: (name: string, value: string) => void;
}

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService implements ILocalStorageService {

  constructor() { }

  get getStoredUser(): any {
    return {
      userName: localStorage.getItem('username')??'',
      pacode: localStorage.getItem('pacode'),
      token: localStorage.getItem('token'),
      jwtToken: localStorage.getItem('jwtToken'),
      role: localStorage.getItem('role'),
      passEcode: localStorage.getItem('passEcode')
    };
  }

  public getItem(name: string): string {
    let cookieValue: string = '';
    const cookieName = `${name}`;
    const documentCookies: Array<string> = document.cookie.split(';');
    documentCookies.forEach((cookie) => {
      while (cookie.startsWith('')) {
        cookie = cookie.substring(1, cookie.length);
      }
       if (cookie.startsWith(cookieName)) {
        cookieValue = cookie.substring(cookie.length, cookie.length);
      }
    });

    return cookieValue;
  }

  public removeItem(name: string): void {
    this.setItem(name, '', -1);
  }

  public setItem(name: string, value: string, expireDays: number = 10000): void {
    const date: Date = new Date();
    date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}`;
  
  }

  public createUserAndStoreInLocal( userData: any): void {
    localStorage.setItem('username', userData[0].username);
    localStorage.setItem('userDealers', JSON.stringify(userData[0].dealers));    
     localStorage.setItem('token',  userData[0].token);
     localStorage.setItem('jwtToken', 'Bearer ' + userData[0].token);
     localStorage.setItem('role', userData[0].role);
     localStorage.setItem('usersFirstName',  userData[0].first_name);
     localStorage.setItem('usersLastName',  userData[0].last_name);
     localStorage.setItem('usersEmail',  userData[0].email);
     localStorage.setItem('passEcode',  userData[0].passEcode);
     
     localStorage.setItem('userDealersDataComplete',  "false");
  }

  public addToLocalStorage(itemName: string, itemValue: any): void {
    localStorage.setItem(itemName, itemValue);
  }

  public retrieveFromLocalStorage(itemName: string): string {
    return localStorage.getItem(itemName) ?? '';
  }
}
